import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import { gql } from '@apollo/client';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import PATIENT_FRAGMENT from '../fragments/patientFragment';
import STUDY_SETTING_FRAGMENT from '../fragments/studySettingFragment';

const UNASSIGNED_STUDIES_QUERY = gql`
  query unassignedStudies($filter: ClinicStudyFilterInput, $limit: Int) {
    clinicStudies(filter: $filter, limit: $limit) {
      id
      friendlyId
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          studyType
          reportDueDate
        }
        studySetting {
          ...StudySettingFragment
        }
      }
      start
      stop
      studyType
      status
      referenceCode
      sentReferenceCodeAt
      reportDueDate
      timezone
      studyTimeOffset
      patientFirstSyncDeviceAt
      initialDurationOfStudy
      ecgUploadProgress
      rma
      artifact {
        date
        resolvedAt
        percentage
        lastIssueFound
        commonIssueFound
      }
      lastStudyHistory {
        time
        status
      }
      hasArtifactReport
      linkedStudies {
        id
        patientFirstSyncDeviceAt
      }
      facility {
        id
        name
        timezone
        contact {
          country
        }
        status
        enableLiveECGStream
        amplifyEcgSignal {
          biotresProDeviceRate
          biotresDeviceRate
          biofluxDeviceRate
        }
      }
      device {
        ...DeviceFragment
      }
      initDuration
      lastEvaluationEvent {
        id
        createdAt
        start
        stripImgs
      }
      biofluxDirect {
        status
        id
        senderInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
        recipientInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
      }
      isTest
      ecgDetail
      uploadStatus
      isStopping
      patientPaired
      orderNumber
      isAborting
      isDeviceAssignmentPending
      initiatedTime
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
  ${STUDY_SETTING_FRAGMENT}
`;

export default UNASSIGNED_STUDIES_QUERY;
